export const CONTRACTS = 'CONTRACTS'
export const CONTRACT = 'CONTRACT'

export default {
    CONTRACTS,
    CONTRACT
}
